import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'

export default [
  // ===
  // 會員等級方案
  // ===
  {
    path: '/memberLevel',
    name: 'level',
    component: () => lazyLoadView(import('@views/MemberLevel/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(!store.state.merchant.currentMerchant?.levelSetting?.isEnabled) {
            next({ name: '404' })
          }
          const [
            list,
          ] = await Promise.all([
            store.dispatch('merchant/fetchMemberLevel'),
          ]);

          routeTo.params.list = list;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      list: route.params.list || {},
    }),
  },
]
